import { render, staticRenderFns } from "./ModalAccessPassword.vue?vue&type=template&id=471c66f1"
import script from "./ModalAccessPassword.vue?vue&type=script&lang=js"
export * from "./ModalAccessPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471c66f1')) {
      api.createRecord('471c66f1', component.options)
    } else {
      api.reload('471c66f1', component.options)
    }
    module.hot.accept("./ModalAccessPassword.vue?vue&type=template&id=471c66f1", function () {
      api.rerender('471c66f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo/ModalAccessPassword.vue"
export default component.exports